var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1982 67.2275V76.6349",
    stroke: "#292929",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3829 36.3387C27.3829 38.4128 17.5311 35.6721 17.5311 45.5238C17.5311 55.3756 17.5311 76.7832 17.5311 76.7832M45.6793 36.3387C45.6793 36.3387 55.0866 37.1389 59.6052 38.8572C64.1237 40.5756 63.3089 50.0422 63.1608 59.7459C63.1608 59.7459 63.0126 63.8942 60.42 64.9313C57.8274 65.9683 33.0126 64.9312 33.0126 64.9312L33.0126 54.4867L41.0867 54.4867",
    stroke: "#292929",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9019 56.1908C25.9019 56.1908 24.9389 54.3389 26.4944 53.0797C28.05 51.8204 29.9759 53.0797 29.9759 53.0797L33.013 55.5241V64.2648H25.9019C25.9019 64.2648 22.6426 63.3759 22.6426 60.0426C22.6426 56.7093 25.9019 56.1908 25.9019 56.1908ZM25.9019 56.1908H28.7167",
    stroke: "#292929",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.198 54.1904L28.5684 37.82L33.161 37.1533L39.0869 54.1904H34.198Z",
    fill: "#B31B34",
    stroke: "#292929",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1982 64.709L47.7538 36.4868L52.2723 37.3757L43.0131 64.709H38.1982Z",
    fill: "#B31B34",
    stroke: "#292929",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4943 49.5239V54.3387H46.5684M50.6424 58.3387V64.9313",
    stroke: "#292929",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4941 68.4868V76.7831",
    stroke: "#292929",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0122 18.7091C49.0122 18.7091 52.864 15.4498 52.9381 11.2276C53.0122 7.0054 50.864 4.85719 50.864 4.85719C50.864 4.85719 49.0862 7.00536 44.2714 4.85725C39.4566 2.70913 35.1603 2.33871 29.6048 6.19066C24.0493 10.0426 30.4936 17.8943 30.4936 17.8943M49.0122 18.7091C49.0122 18.7091 50.6567 18.3475 51.6789 19.4498C52.3272 20.149 52.6208 21.8355 52.4196 23.3017C51.9011 27.0794 47.9011 27.5239 47.9011 27.5239M49.0122 18.7091C49.0122 20.1906 47.9011 27.5239 47.9011 27.5239M49.0122 18.7091C49.0122 17.2276 46.3455 14.9313 46.3455 14.9313C46.3455 14.9313 44.6418 16.635 43.3085 16.9313C41.9752 17.2276 39.7529 16.9313 39.7529 16.9313M36.9381 15.9683L35.0862 14.9313L31.827 19.4498C31.827 19.4498 29.4566 18.3387 28.3455 19.4498C27.2344 20.5609 26.1973 22.3387 28.3455 25.3017C30.4936 28.2646 31.827 27.5239 31.827 27.5239C31.827 27.5239 32.9186 30.7148 36.2714 32.45M47.9011 27.5239C47.9011 27.5239 47.3905 30.9015 44.5677 32.5949M36.2714 32.45C37.372 33.0196 38.7163 33.4324 40.3455 33.5239C42.1377 33.6246 43.5139 33.2271 44.5677 32.5949M36.2714 32.45C36.2714 32.45 35.0863 41.2276 40.3455 41.2276C45.6048 41.2276 44.5677 32.5949 44.5677 32.5949",
    stroke: "#292929",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpa);
export default __webpack_public_path__ + "static/media/gpa.dc0e11ec5e025498285d0f155928d460.svg";
export { ForwardRef as ReactComponent };